export const localWidgetFocusKey = {
  row: (parentFocusKey: string, idx: number) => parentFocusKey + ".list." + idx,
  col: (parentFocusKey: string, rowIdx: number, itemIdx: number) => {
    return localWidgetFocusKey.row(parentFocusKey, rowIdx) + ".item." + itemIdx;
  },
};
